import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, rem } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var useStyles = createStyles(function (theme, _ref, _ref2) {
  var radius = _ref.radius;
  var size = _ref2.size;
  var overlayColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
  return {
    root: __spreadProps(__spreadValues({}, theme.fn.focusStyles()), {
      width: rem(size),
      height: rem(size),
      WebkitTapHighlightColor: "transparent",
      border: 0,
      borderRadius: theme.fn.radius(radius),
      appearance: "none",
      WebkitAppearance: "none",
      padding: 0,
      position: "relative",
      overflow: "hidden"
    }),
    overlay: __spreadProps(__spreadValues({}, theme.fn.cover()), {
      position: "absolute",
      borderRadius: theme.fn.radius(radius)
    }),
    children: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center"
    },
    shadowOverlay: {
      boxShadow: "rgba(0, 0, 0, .1) 0 0 0 ".concat(rem(1), " inset, rgb(0, 0, 0, .15) 0 0 ").concat(rem(4), " inset"),
      zIndex: 1
    },
    alphaOverlay: {
      backgroundImage: "linear-gradient(45deg, ".concat(overlayColor, " 25%, transparent 25%), linear-gradient(-45deg, ").concat(overlayColor, " 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ").concat(overlayColor, " 75%), linear-gradient(-45deg, ").concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white, " 75%, ").concat(overlayColor, " 75%)"),
      backgroundSize: "".concat(rem(8), " ").concat(rem(8)),
      backgroundPosition: "0 0, 0 ".concat(rem(4), ", ").concat(rem(4), " -").concat(rem(4), ", -").concat(rem(4), " 0")
    }
  };
});
export default useStyles;